"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.number.constructor");require("core-js/modules/es6.object.keys");require("core-js/modules/web.dom.iterable");










































































































var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { searchData: { appId: '', terminalType: '', appVersion: '', page: 1, rows: 10 }, //搜索表单
      searchData1: { page: 1, rows: 10 }, //WiFi板||语音板搜索表单
      pageData: { page: 1, rows: 10, total: 0, pages: 1 }, //分页数据
      auditStatus: 0, //升级任务审核状态;1:已审核；0：未审核。
      upgradeId: 0, //升级任务id
      upgradeType: 0, //升级任务类型。1：中心板；2：WiFi板；3：语音板。
      deviceTypeId: 0, //设备型号id
      showDialog: false, //是否显示新增||编辑中心板弹窗
      showDialog1: false, //是否显示新增||编辑WiFi板及语音板弹窗
      tableColumns: [{ prop: 'appName', label: 'app名称' }, { prop: 'terminalType', label: '终端', formatter: _formatter.terminalTypeFormatter }, { prop: 'appVersion', label: '兼容app版本' }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter }], //中心板表格信息
      tableColumns1: [{ prop: 'deviceType', label: '设备类型' }, { prop: 'limitOtaVersion', label: '中心板版本' }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter }], //WiFi板||语音板表格信息
      list: [], //表格数据
      versionForm: { id: 0, appId: '', terminalType: '', appVersion: '' }, //兼容表单
      versionFormRule: { appId: [{ required: true, message: '请选择APP名称', trigger: ['blur', 'change'] }], terminalType: [{ required: true, message: '请选择终端', trigger: ['blur', 'change'] }], appVersion: [{ required: true, message: '请选择兼容版本', trigger: ['blur', 'change'] }] }, //兼容表单验证规则
      versionForm1: { id: 0, limitOtaVersionInfoId: '' }, //WiFi板||语音板兼容表单
      versionFormRule1: { limitOtaVersionInfoId: [{ required: true, message: '请选择中心板版本', trigger: ['blur', 'change'] }] }, //WiFi板||语音板兼容表单验证规则
      appList: [], //APP列表
      versionList: [], //版本列表
      currentVersionInfo: '', //当前正在编辑的版本信息
      hardwareList: [] //固件版本列表
    };}, mounted: function mounted() {this.auditStatus = this.$route.params.auditStatus;this.upgradeId = this.$route.params.parentId;this.upgradeType = this.$route.params.type;this.deviceTypeId = this.$route.params.deviceTypeId;this.initPage();}, methods: { /**
                                                                                                                                                                                                                                                                   * 页面初始化
                                                                                                                                                                                                                                                                   */initPage: function initPage() {if (this.upgradeType == 1) {this.fetchCompatibleVersionList();} else {this.fetchCompatibleVersionList1();}this.fetchAppList();}, /**
                                                                                                                                                                                                                                                                                                                                                                                                                                      * 获取兼容版本列表
                                                                                                                                                                                                                                                                                                                                                                                                                                      */fetchCompatibleVersionList: function fetchCompatibleVersionList() {var _this = this;var params = Object.assign({}, this.searchData);params.otaVersionJobId = this.upgradeId;
      params.type = 1;
      this.getData('/api/faOtaVersionLimit', params, function (res) {
        _this.list = res.list;
        _this.pageData.page = res.pageNum;
        _this.pageData.total = res.total;
      });
    },

    /**
        * 获取WiFi板||语音板兼容版本列表
        */
    fetchCompatibleVersionList1: function fetchCompatibleVersionList1() {var _this2 = this;
      var params = Object.assign({}, this.searchData1);
      params.type = 3;
      this.getData('/api/faOtaVersionLimit/limitVersionJob/' + this.upgradeId, params, function (res) {
        _this2.list = res.list;
        _this2.pageData.page = res.pageNum;
        _this2.pageData.total = res.total;
      });
    },

    /**
        * 获取app列表
        */
    fetchAppList: function fetchAppList() {var _this3 = this;
      this.getData('/api/appVersion/apps', {}, function (res) {
        _this3.appList = res;
      });
    },

    /**
        * 获取版本列表
        */
    fetchVersionList: function fetchVersionList() {var _this4 = this;
      this.getData('/api/appVersion/versions', { appId: this.versionForm.appId, terminalType: this.versionForm.terminalType }, function (res) {
        _this4.versionList = res;
      });
    },

    /**
        * 获取固件版本下拉列表
        */
    fetchHardwareVersionInfoList: function fetchHardwareVersionInfoList(val) {var _this5 = this;
      this.getData('/api/versionInfo/getDownList', { firmwareType: 1, otaVersion: val }, function (res) {
        _this5.hardwareList = res;
      });
    },

    /**
        * 返回
        */
    onClickReturn: function onClickReturn() {
      this.$router.push('/ota/upgrade');
    },

    /**
        * 重置
        */
    onClickReset: function onClickReset() {
      this.$set(this.searchData, 'appId', '');
      this.$set(this.searchData, 'terminalType', '');
      this.$set(this.searchData, 'appVersion', '');
      this.$set(this.searchData, 'page', 1);
      this.fetchCompatibleVersionList();
    },

    /**
        * 每页size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      if (this.upgradeType == 1) {
        this.searchData.rows = val;
        this.searchData.page = 1;
        this.fetchCompatibleVersionList();
      } else {
        this.searchData1.rows = val;
        this.searchData1.page = 1;
        this.fetchCompatibleVersionList1();
      }
    },

    /**
        * 页码-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      if (this.upgradeType == 1) {
        this.searchData.page = val;
        this.fetchCompatibleVersionList();
      } else {
        this.searchData1.page = val;
        this.fetchCompatibleVersionList1();
      }
    },

    /**
        * 编辑
        */
    onClickUpdate: function onClickUpdate(row) {
      this.showDialog = true;
      this.currentVersionInfo = Object.assign({}, row);
      this.$set(this.versionForm, 'id', row.id);
      this.$set(this.versionForm, 'appId', row.appId);
      this.$set(this.versionForm, 'terminalType', row.terminalType + '');
      this.$set(this.versionForm, 'appVersion', row.appVersion);
      this.fetchVersionList();
    },

    /**
        * 删除
        */
    onClickDelete: function onClickDelete(row) {var _this6 = this;
      this.$confirm('确定删除当前兼容版本？', '提示', { type: 'warning' }).then(function (res) {
        //删除兼容版本
        _this6.delData('/api/faOtaVersionLimit/' + row.id, {}, function (res) {
          _this6.fetchCompatibleVersionList();
        });
      }).catch(function (err) {

      });
    },

    /**
        * 弹窗关闭-回调
        */
    onDialogClose: function onDialogClose() {var _this7 = this;
      this.$nextTick(function () {
        Object.keys(_this7.versionForm).forEach(function (key) {
          _this7.$set(_this7.versionForm, key, key == 'id' ? 0 : '');
        });
        _this7.$refs.versionForm.clearValidate();
      });
      this.showDialog = false;
      this.currentVersionInfo = '';
    },

    /**
        * APP名称-change
        */
    onAppIdChange: function onAppIdChange(value) {
      if (this.versionForm.appId && this.versionForm.terminalType) {
        this.fetchVersionList();
      } else {
        this.$set(this.versionForm, 'appVersion', '');
      }
    },

    /**
        * 终端-change
        */
    onTerminalTypeChange: function onTerminalTypeChange(value) {
      if (this.versionForm.appId && this.versionForm.terminalType) {
        this.fetchVersionList();
      } else {
        this.$set(this.versionForm, 'appVersion', '');
      }
    },

    /**
        * 新增||保存兼容版本
        */
    onSubmitVersion: function onSubmitVersion() {var _this8 = this;
      this.$refs.versionForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this8.versionForm);
          params.otaVersionJobId = _this8.upgradeId;
          if (params.id) {
            //编辑
            _this8.postData('/api/faOtaVersionLimit', params, function (res) {
              _this8.onDialogClose();
              _this8.fetchCompatibleVersionList();
            });
          } else {
            //新增
            delete params['id'];
            _this8.postData('/api/faOtaVersionLimit', params, function (res) {
              _this8.onDialogClose();
              _this8.$set(_this8.searchData, 'page', 1);
              _this8.fetchCompatibleVersionList();
            });
          }
        }
      });
    },

    /**
        * WiFi板||语音板弹窗关闭
        */
    onDialogClose1: function onDialogClose1() {var _this9 = this;
      this.showDialog1 = false;
      this.currentVersionInfo = '';
      this.$nextTick(function () {
        Object.keys(_this9.versionForm1).forEach(function (key) {
          _this9.$set(_this9.versionForm1, key, key == 'id' ? 0 : '');
        });
        _this9.$refs.versionForm1.clearValidate();
      });
    },

    /**
        * 编辑WiFi板||语音板
        */
    onClickUpdate1: function onClickUpdate1(row) {
      this.showDialog1 = true;
      this.$set(this.versionForm1, 'id', row.id);
      this.$set(this.versionForm1, 'limitOtaVersionInfoId', Number(row.limitOtaVersionInfoId));
      this.fetchHardwareVersionInfoList();
    },

    /**
        * 删除WiFi板||语音板
        */
    onClickDelete1: function onClickDelete1(row) {var _this10 = this;
      this.$confirm('确定删除当前兼容版本？', '提示', { type: 'warning' }).then(function (res) {
        //删除兼容版本
        _this10.delData('/api/faOtaVersionLimit/' + row.id, {}, function (res) {
          _this10.fetchCompatibleVersionList1();
        });
      }).catch(function (err) {

      });
    },

    /**
        * 提交WiFi板||语音板兼容版本
        */
    onSubmitVersion1: function onSubmitVersion1() {var _this11 = this;
      this.$refs.versionForm1.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this11.versionForm1);
          params.otaVersionJobId = _this11.upgradeId;
          params.deviceTypeId = _this11.deviceTypeId;
          if (params.id) {
            //编辑
            _this11.postData('/api/faOtaVersionLimit/range', params, function (res) {
              _this11.onDialogClose1();
              _this11.fetchCompatibleVersionList1();
            });
          } else {
            //新增
            delete params['id'];
            _this11.postData('/api/faOtaVersionLimit/range', params, function (res) {
              _this11.onDialogClose1();
              _this11.$set(_this11.searchData, 'page', 1);
              _this11.fetchCompatibleVersionList1();
            });
          }
        }
      });
    } } };exports.default = _default;